import { Button } from "../components/Button";
import { HistoryIcon, SparkIcon } from "../components/Icons";
import { ScreenShell } from "../components/ScreenShell";
import { useUiText } from "../i18n/useUiText";
import { useAppStore } from "../state/useAppStore";

export function HistoryScreen() {
  const t = useUiText();
  const session = useAppStore((state) => state.session);
  const history = useAppStore((state) => state.history);
  const closeHistory = useAppStore((state) => state.closeHistory);
  const openReveal = useAppStore((state) => state.openReveal);
  const undoLastDiscard = useAppStore((state) => state.undoLastDiscard);

  if (session === null) {
    return null;
  }

  return (
    <ScreenShell
      backLabel={t("history.back")}
      footer={
        <div className="footer-row">
          <Button
            disabled={history.length === 0}
            onClick={undoLastDiscard}
            variant="secondary"
            wide
          >
            {t("history.undo")}
          </Button>
          <Button onClick={closeHistory} wide>
            {t("history.back")}
          </Button>
        </div>
      }
      onBack={closeHistory}
    >
      <div className="narrow-column history-screen">
        <header className="screen-heading">
          <h1>{t("history.title")}</h1>
          <p>{t("history.body")}</p>
        </header>

        {history.length === 0 ? (
          <div className="empty-history">
            <HistoryIcon />
            <p>{t("history.empty")}</p>
          </div>
        ) : (
          <ol className="history-list" lang={session.theme.contentLocale}>
            {history.map((entry, index) => (
              <li key={entry.historyId}>
                <button
                  className="history-item"
                  onClick={() => openReveal(entry.card.cardId, "history")}
                  type="button"
                >
                  <span className="history-item__index">{index + 1}</span>
                  <span className="history-item__word">
                    {entry.card.displayText}
                  </span>
                  {entry.card.cardKind === "DUAL" ? (
                    <span className="history-item__kind">
                      <SparkIcon />
                      {t("card.dual")}
                    </span>
                  ) : null}
                  <span className="history-item__action">
                    {t("history.showAgain")}
                  </span>
                </button>
              </li>
            ))}
          </ol>
        )}
      </div>
    </ScreenShell>
  );
}
